import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlValidator(control: AbstractControl): ValidationErrors | null {
  const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([a-z\.]{2,6})(\/[\w\-._~:/?#[\]@!$&'()*+,;=.]+)*\/?$/i;
  const value = control.value;

  if (!value) return null; // empty value is allowed, not required
  return urlPattern.test(value) ? null : { invalidUrl: true };
}
